import * as React from 'react'
import { inject } from 'mobx-react'
import { ProductV2Api, ProductV2Models } from '@getgreenline/products'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { parseErrorMsg } from '../../../../utilities/helpers'
import { message } from 'antd-v4'
import * as file from '../../../../utilities/file'
import { BlazeButton } from '../../../../components/CustomButtons/BlazeButton'

interface IProps {
  widthBreakPoint?: number
  currentCompanyStore?: CurrentCompanyStore
}

export const ExportProductButton = inject('currentCompanyStore')((props: IProps) => {
  if (!props.currentCompanyStore?.company || !props.currentCompanyStore?.productStore) return null
  const [isLoading, setIsLoading] = React.useState(false)

  const { company, productStore } = props.currentCompanyStore

  const downloadProductsExport = async () => {
    try {
      setIsLoading(true)
      if (!productStore.productFilter) throw new Error('A filter is required to export products')
      const { signedUrl, fileName } = await ProductV2Api.getProductsExport(company.id, {
        ...productStore.productFilter.productFilter,
        fileType: ProductV2Models.ProductsFileType.CSV,
        limit: 30000, // https://blaze-cmp.slack.com/archives/C03KGV2T480/p1705016732992769?thread_ts=1705015277.707139&cid=C03KGV2T480
        offset: 0,
      })
      file.download(signedUrl, fileName)
    } catch (error) {
      message.error(parseErrorMsg(error) || 'An error occurred while exporting product list')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <BlazeButton
      buttonProps={{
        icon: 'download',
        disabled: isLoading,
        onClick: downloadProductsExport,
        loading: isLoading,
      }}
      titleProps={{
        title: 'Export csv',
        widthBreakPoint: props.widthBreakPoint,
      }}
    />
  )
})
